import { render } from "./new-link-client.vue?vue&type=template&id=491273f7"
import script from "./new-link-client.vue?vue&type=script&lang=js"
export * from "./new-link-client.vue?vue&type=script&lang=js"

import "./new-link-client.vue?vue&type=style&index=0&id=491273f7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__